import validator from 'validator';
import { FormValidator, ValidationResult } from '../formField/types/form-validator';

export const DomainValidator: (errorMessage: string, allowWildcards?: boolean) => FormValidator = (
  errorMessage: string,
  allowWildcards = false
) => {
  return async (value: string): Promise<ValidationResult> => {
    if (!value) {
      return { valid: true };
    }

    if (allowWildcards) {
      const regex = /[\?\*\[\]\!]+/;

      if (regex.test(value)) {
        return {
          valid: true
        };
      }
    }

    if (validator.isFQDN(value)) {
      return { valid: true };
    }

    return {
      valid: false,
      error: errorMessage,
    };
  };
};
